import { Injectable } from '@angular/core';
import { getPropVal } from '@finegold/base';
import { Observable, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { TableDef } from '../meta/appconfig';
import { EntityDatasource } from '../meta/entitydatasource';
import { EntityApi, EntityInfo, EntityMeta, EntityPropType, RestApiInfo } from '../meta/entitymetadata';
import { ID } from '../model/baseentity';
import { sortList } from '../restquery/localquery';
import { orderByToSorts } from '../restquery/restquery';
import { CacheService } from './cacheservice';
import { AppRest } from './rest';

/**
 * å®ä½åæ°æ®DAOï¼å¸¦ç¼å­åè½
 */

@Injectable()
export class MetadataDao {

    get metaApiUrl() {
        let metaApi = this.appRest.appConfig.metaApiUrl;
        if (!metaApi) {
            throw 'not set metadata-api'
        }
        return metaApi;
    }

    constructor(private appRest: AppRest,
        private cacheService: CacheService) {
    }


    /**
     * è·å Exported çå®ä½åè¡¨ã
     * exported: æçæ¯å­å¨å¯¹åºBaseControllerçå®ä½ã
     */
    getEntityList(): Observable<EntityInfo[]> {
        let key = `__meta_entitylist_$`
        let meta = this.cacheService.get(key);
        if (meta) {
            return of(meta)
        } else {
            return this.appRest.get(`${this.metaApiUrl}/entitylist`).pipe(
                tap(m => this.cacheService.add(key, m))
            )
        }
    }

    /**
     * è·åç³»ç»ææAPIåè¡¨
     */
    getAppApis(): Observable<RestApiInfo[]> {
        return this.appRest.get(`${this.metaApiUrl}/apis`);
    }

    /**
     * è·åå®ä½APIåè¡¨
     * @param entityName
     */
    getEntityApi(entityName: string): Observable<EntityApi[]> {
        return this.appRest.get(`${this.metaApiUrl}/apis/${entityName}`);
    }

    /**
     * è·åå®ä½åæ°æ®
     * @param entName å®ä½åç§°
     * @param flat æ¯å¦å±å¼å¼ç¨å®ä½çåæ°æ®
     */
    getMetadata(entName: string, flat?: boolean): Observable<EntityMeta> {
        let key = `__meta_${entName}-${flat ? '1' : '0'}`
        let meta = this.cacheService.get(key);
        if (meta) {
            return of(meta)
        } else {
            let meta$: Observable<EntityMeta>
            if (this.metaApiUrl) {
                meta$ = this.appRest.get(`${this.metaApiUrl}/${entName}`, {
                    nonFlat: flat ? '0' : '1'
                })
            } else {
                const tbl: TableDef = this.appRest.appConfig.getEntity(entName);
                let url = tbl.url;
                meta$ = this.appRest.get(`${url}/_metadata?flat=${flat ? '1' : '0'}`);
            }
            return meta$.pipe(
                tap(m => this.cacheService.add(key, m))
            )
        }
    }

    /**
     * è·ååæ°æ®å¯å¼ç¨çæ°æ®æº
     */
    getDatasources(): Observable<EntityDatasource[]> {
        let key = '__metadatasource';
        let ds = this.cacheService.get(key);
        if (ds) {
            return of(ds)
        } else {
            return this.appRest.get(`${this.metaApiUrl}/datasources`).pipe(
                tap(data => this.cacheService.add(key, data))
            )
        }
    }

    /**
     * è·åæ°æ®æºæ°æ®
     * @param entName
     * @param pid
     * @param nested
     */
    getDatasoureceDatas(entName: string, pid?: ID, nested?: boolean): Observable<any[]> {
        let tbl = this.appRest.appConfig.getEntity(entName)

        let datas = tbl.cachable ? this.cacheService.getEntity(entName) : null;
        let data$ = datas
            ? of(datas)
            : this.appRest.get(`${this.metaApiUrl}/datasources/${entName}`).pipe(
                tap((datas: any[]) => {
                    this.cacheService.addEntity(entName, datas);
                })
            )

        return this.getMetadata(entName).pipe(
            switchMap(meta => data$.pipe(
                map(list => {
                    let ret = list;
                    let sortProp = meta.sortProp || meta.nameProp;
                    if (meta.parentProp) {
                        if (pid || !nested) {
                            let codeFld = meta.props.find(it => it.isInnercode);
                            let pidProp = meta.parentPropType == EntityPropType.ENTITY_PROPTYPE_REF
                                ? meta.parentProp + '.id'
                                : meta.parentProp

                            let roots = list.filter(it => !pid
                                ? getPropVal(it, pidProp) == pid
                                : !getPropVal(it, pidProp))
                            if (nested) {
                                let rootCodes: string[] = roots.map(it => it[codeFld.propName])
                                ret = list.filter(it =>
                                    !!rootCodes.find(code =>
                                        (it[codeFld.propName] as string).startsWith(code)))
                            }
                        }
                    }
                    return sortList(ret, orderByToSorts(sortProp));
                })
            ))
        )

    }
}